import React, { ReactNode } from "react";
import classnames from "classnames";
import styles from "./IsMobile.module.scss";

const IsMobile = ({ children }: IsMobileProps) => (
  <>
    {children &&
      React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          className: classnames(child.props.className, styles.isMobile)
        })
      )}
  </>
);

export default IsMobile;

interface IsMobileProps {
  children: ReactNode;
}
